<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="送货单详情"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="delivery"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">送货单号:</td>
            <td style="width: 23%">{{delivery.no}}</td>
            <td class="tableLabel">供应商编码:</td>
            <td style="width: 23%">{{delivery.supplierNo}}</td>
            <td class="tableLabel">供应商名称:</td>
            <td style="width: 23%">{{delivery.supplierName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">采购组:</td>
            <td>{{delivery.buyUserName}}</td>
            <td class="tableLabel">制单人:</td>
            <td>{{delivery.creatorName}}</td>
            <td class="tableLabel">制单时间:</td>
            <td>{{delivery.createdTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">到货时间:</td>
            <td>{{delivery.arrivedTime}}</td>
            <td class="tableLabel">入库时间:</td>
            <td>{{delivery.inStockTime}}</td>
            <td class="tableLabel">入库人员:</td>
            <td>{{delivery.inStockUserName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">预计到货日期:</td>
            <td>{{delivery.plannedArrivalTime}}</td>
            <td class="tableLabel">送货地址:</td>
            <td colspan="3">{{delivery.purchaseReceiveAddress}}</td>
          </tr>
          <tr>
            <td class="tableLabel">备注:</td>
            <td>{{delivery.note}}</td>
            <td class="tableLabel">关联发货单号</td>
            <td colspan="3">{{delivery.deliveryNo}}</td>
          </tr>
        </table>
        <el-table
            :data="delivery.receiveDetails"
            border
            height="40vh"
            style="width: 100%;overflow-y:scroll">
          <el-table-column prop="podetailRowNO" align="center" label="行号" width="80"/>
          <el-table-column
              prop="evaluate"
              align="center"
              label="采购订单"
              show-overflow-tooltip
              width="100"/>
          <el-table-column
              prop="sapmaterialNO"
              align="center"
              label="物料编号"
              show-overflow-tooltip
              width="120"/>
          <el-table-column
              prop="sapmaterialName"
              align="left"
              label="物料描述"
              min-width="120"
              show-overflow-tooltip/>
          <el-table-column prop="responseDeliveryTime" align="center" label="交货期" width="100">
            <template slot-scope="scope">
              <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="sumQuantity" align="center" label="数量" width="70"/>
          <el-table-column prop="hasReceiveQty" align="center" label="已送数量" width="70"/>
          <el-table-column prop="quantity" align="center" label="本次送货数量" width="100">
            <!--            <template slot-scope="scope">-->
            <!--              <el-input v-model.trim="scope.row.quantity" placeholder="请输入" @input="checkQuantity(scope.row)"/>-->
            <!--            </template>-->
          </el-table-column>
          <el-table-column prop="note" align="center" label="备注" width="150"/>
        </el-table>
        <div style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
          订单附件
        </div>
        <el-upload
            action=""
            :http-request="submitUpload"
            :file-list="files"
            :show-file-list="false"
            style="float: left; margin-right: 5px">
          <el-button :v-loading="uploadLoading" type="primary" style="margin-bottom: 10px"> 添加附件</el-button>
        </el-upload>
        <el-table border :data="delivery.accessoryList">
          <el-table-column type="index" align="center" label="#" width="55"/>
          <el-table-column prop="accessoryName" align="left" label="附件描述" show-overflow-tooltip/>
          <el-table-column label="下载" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" @click="download(scope.row)">下载</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import loginUtil from "@/util/loginUtil";

  export default {
    name:"DeliveryDetail",
    components: {},
    data() {
      return {
        constant,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        files: [],
        fileList: [],
        delivery: {
          pkid:"",
          no:"",//送货单号
          supplierNo: "", // 供应商编码
          supplierName: "", // 供应商名称
          factoryName: "", // 工厂
          deliveryAddress: "", // 收货地址
          shipper: "", // 发货人
          shipperPhone: "", // 发货人联系方式
          deliveryMethod: "", // 送货方式
          plannedArrivalTime: "", // 预计发货日期
          deliveryDate: "", // 预计到货日期
          note: "", // 备注
          receiveDetails: [], // 送货单明细
          accessoryList:[],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.delivery.pkid = id;
        this.dialogVisible = true;
        this.getData();
      },
      getData() {
        this.$http.get("basic", "purchaseReceives/getPurchaseReceiveById/" + this.delivery.pkid)
          .then((resp) => {
            console.log(resp);
            this.delivery = resp;
          });
      },
      download(row) {
        let data = {
          name:row.accessoryName,
          uuid:row.filePath,
        };
        this.$http.exportFile("basic","file/download",data).then(res => {
          console.log(res);
          let blob = new Blob([res.data],{type:"application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        var pkid = {
          pkid:this.delivery.pkid,
        };
        this.$http
          .post("basic", "purchaseReceives/uploadReceipt",formData,pkid)
          .then((res) => {
            if(res.success) {
              this.uploadLoading = false;
              this.$message.success("上传成功");
              this.getData();
            }
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .purchaseOrder{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border: 1px solid #EBEEF5;
      border-bottom: none;
      border-left: none;
      margin-bottom: 15px;
    }
    table.gridtable tr td {
      padding: 8px;
      border-left: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
      border-left: 1px solid #EBEEF5;
    }
  }

</style>
